import React from "react";

export default function SQL_VALUES() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_VALUES</h1>
      <p>This is the SQL_VALUES component generated from the SQL JSON.</p>
    </div>
  );
}
